type FormatPriceOptions = {
    prefix?: string
    showCents?: boolean
    maxFractionDigits?: number
}

/**
 * Formats a monetary amount with comma grouping and optional cents.
 * Omits the decimal portion when the value is a whole number of dollars.
 *
 * Pass `showCents: false` for scanning surfaces that want whole dollars regardless.
 * Those cents are truncated rather than rounded, so the shortened figure never reads
 * higher than the amount it stands for.
 */
export function formatPrice(amount: number, options: FormatPriceOptions = {}): string {
    const prefix = options.prefix ?? '$'

    if (options.showCents === false) {
        return `${prefix}${Math.trunc(amount).toLocaleString('en-US')}`
    }

    const hasCents = Math.round(amount * 100) % 100 !== 0
    const formatted = amount.toLocaleString('en-US', {
        minimumFractionDigits: hasCents ? 2 : 0,
        maximumFractionDigits: options.maxFractionDigits ?? 2,
    })
    return `${prefix}${formatted}`
}
